module.exports = __webpack_public_path__ + "img/close.b21cead1.svg";